import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createStructuredSelector } from 'reselect';
// import { sendQuoteCreateQuote } from '@om/redux/actions/kaMetlhaFuneralCover/quote';
// import { toggleQuoteCallMeBack } from '@om/redux/actions/kaMetlhaFuneralCover/callMeBack';
// import { getQuoteSummary } from '@om/redux/selectors/kaMetlhaFuneralCover/quote';
// import { OmIcon } from '@om/component-library-react';
// import OmButton from '../../../components/forms/OmButton';
import { navigateToReplacementPolicy } from '@om/redux/actions/kaMetlhaFuneralCover/routing';

import './BwQuoteSummaryCard.scss';
import OmButton from '../../../../components/forms/OmButton';
import { KMF_COVER_CATEGORIES, PAGES } from '@om/redux/actions/kaMetlhaFuneralCover/types';
import { navigate } from 'gatsby';
import { getFinalQuotation, getLivesCovered } from '@om/redux/selectors/kaMetlhaFuneralCover/quote';
import { setQuoteDrawerValue } from '@om/redux/actions/kaMetlhaFuneralCover/quote';
import { setLeadSystem, setProductNameValue } from '@om/redux/actions/publicWeb/callMeBack';
import { getQuoteResponse } from '@om/redux/selectors/kaMetlhaFuneralCover/referenceData';
import { sendLeadsRequest } from '@om/redux/actions/kaMetlhaFuneralCover/policyRequest';


const BwQuoteSummaryCard = ({ isSticky, name, withoutbuttons,isBuyNowDisabled }) => {

    const dispatch = useDispatch();
    const { quoteValue:{funeralPremium:quoteSummary}, livesCovered } = useSelector(
        createStructuredSelector({
            // quoteSummary: getFinalQuotation,
            livesCovered: getLivesCovered,
            quoteValue:getQuoteResponse
        })
    );

    // const coverAmount = JSON.parse(quoteSummary.categoryAmounts);
    // const coverCat = JSON.parse(quoteSummary.categories);
    // const totalQuoting = coverAmount?.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
    const [isExpanded, setIsExpanded] = useState(withoutbuttons);
    const toggleExpand = () => {
        setIsExpanded(!isExpanded);
    };
    return (
        <>
            <div className="sticky-summary-card-wrapper FuneralQuotingSummary">
                <div className="heading-group" >
                    <div className="group-left">
                        <p className="summary-heading">Quote summary</p>
                    </div>
                    {!withoutbuttons && <div className="group-right">
                        <strong >P {quoteSummary ? (+quoteSummary?.toFixed(2)) : ''} p/m</strong>
                    </div>}
                    {/* <div className='heading-wrapper'>
                        <h4 className="heading-total-text">P{totalQuoting} p/m</h4>
                        <OmIcon iconName={`${isExpanded ? 'expand_less' : 'expand_more'}`} />
                    </div> */}
                </div>
                {withoutbuttons && <div className={`content ${isExpanded ? 'card-contents expanded' : 'card-contents'}`}>
                    <div className="selectable-container">

                        <div className="family-group" >
                            <p className="family-text">Here is your total funeral cover cost
                            </p>
                            <p className="family-cover-amount">P {quoteSummary ? (+quoteSummary?.toFixed(2)) : ''} p/m</p>
                        </div>

                    </div>
                </div>}
                {!withoutbuttons && <div className="footer-group purchase">
                    <h6 className="button-text">Are you ready to purchase Ka-Metlha Funeral Cover? During the purchase journey, the premium may change based on member details.</h6>
                    <div className="button-container">
                        <div className="left">
                            <OmButton
                                size="small"
                                type="secondary"
                                text="CALL ME BACK"
                                actionObject={ {
                                    __typename: 'Contentstack_call_me_back_email',
                                    call_me_back_product: 'Ka Metlha Funeral',
                                    email: 'contactus@oldmutual.co.bw',
                                    privacy_policy_url: '/about-old-mutual/privacy-policy/'
                                }}
                                onClick={() => {
                                    dispatch(setLeadSystem('bw'))
                                    dispatch(setProductNameValue('Ka-Metlha Funeral Cover'))

                                }}
                            />
                        </div>
                        <div className="right">
                            <OmButton
                                type='primary'
                                size='small'
                                text="Buy Now"
                                disabled={!isBuyNowDisabled}
                                onClick={() => {
                                    if (Object.keys(livesCovered[KMF_COVER_CATEGORIES.AGENT]).length) {
                                        dispatch(navigateToReplacementPolicy())
                                        navigate(PAGES[0].URL);
                                    } else {
                                        dispatch(sendLeadsRequest());
                                        dispatch(setQuoteDrawerValue({
                                            fieldType: 'coverType',
                                            value: KMF_COVER_CATEGORIES.AGENT,
                                        }))
                                    }

                                }}>

                            </OmButton>
                        </div>
                        
                    </div>
                </div>}
            </div>
        </>
    );
};

export default BwQuoteSummaryCard;
